<template>
  <EhouseDoubleCalculatingList />
</template>

<script>
import EhouseDoubleCalculatingList from "@/components/Calculatings/EhouseDoubleCalculating/List.vue";
export default {
  components: { EhouseDoubleCalculatingList },
};
</script>

<style></style>
